import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { InvoiceListComponent } from '../invoice-list/invoice-list.component';

@Component({
  selector: 'app-invoice-user-list',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./invoice-user-list.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class InvoiceUserListComponent extends InvoiceListComponent implements OnInit, OnChanges {

  @Input() userid: any;

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service, route, router);
    this.subentity = 'user';
    this.subtitle = '_USER';
  }

  getBody(): any {
    const body = super.getBody();
    if (this.userid) {
      body.mode = 'user';
      body.query = [['username', '=', this.userid], 'and', ['status', '<>', 'D']];
    }
    return body;
  }

  async ngOnInit() {
    await super.ngOnInit();
    if (this.meta) {
      this.pageTitle = `${this.selectedAccount ? this.selectedAccount : this.translator.instant('APP_NAME')} :: ${this.userid || ''} :: ${this.meta.caption}`;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.userid && this.meta) {
      this.pageTitle = `${this.selectedAccount ? this.selectedAccount : this.translator.instant('APP_NAME')} :: ${this.userid || ''} :: ${this.meta.caption}`;
      this.load();
    }
  }

}
